import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient';
import { config } from '../lib/config';
import { demoStore } from '../features/demo/store';

export const useForums = () => useQuery({ queryKey:['forums'], staleTime:30000, queryFn:async () => { if (config.e2e) return demoStore.forums(); const { data,error } = await supabase.from('forums').select('*').order('is_section').order('name'); if (error) throw error; return data; } });
